export default "__VITE_ASSET__CGrlBAhJ__"